// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LmRG","fullView":"styles_fullView__cpFXT"};